import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { chatAPI } from 'services/api';
import { RootState } from 'store/rootReducer';

export declare interface EquipeInterface {
  id: string;
  nome: string;
}

export declare interface EquipeInterfaceV2 {
  id: string;
  name: string;
  description?: string;
}

type EquipesState = {
  equipes: EquipeInterface[];
  loadingEquipes: boolean;

  equipesPorAtendente: EquipeInterfaceV2[];
  loadingEquipesPorAtendente: boolean;
};

// async thunks

export const fetchEquipes = createAsyncThunk(
  'equipes/fetchEquipes',
  async () => {
    const response = await chatAPI.get('equipes');
    return response.data.data as EquipeInterface[];
  },
);

export const fetchEquipesPorAtendente = createAsyncThunk(
  'equipes/fetchEquipesPorAtendente',
  async (userId: string) => {
    const response = await chatAPI.get('v2/teams/select', {
      params: { userId },
    });
    return response.data as EquipeInterfaceV2[];
  },
);

// reducer

const initialState = {
  equipes: [],
  loadingEquipes: false,

  equipesPorAtendente: [],
  loadingEquipesPorAtendente: false,
} as EquipesState;

export const equipesSlice = createSlice({
  name: 'equipes',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // Fetch equipes
    builder.addCase(fetchEquipes.pending, state => {
      state.loadingEquipes = true;
    });
    builder.addCase(fetchEquipes.fulfilled, (state, action) => {
      state.equipes = action.payload;
      state.loadingEquipes = false;
    });

    // Fetch equipes por atendente
    builder.addCase(fetchEquipesPorAtendente.pending, state => {
      state.loadingEquipesPorAtendente = true;
      state.equipesPorAtendente = [];
    });
    builder.addCase(fetchEquipesPorAtendente.fulfilled, (state, action) => {
      state.equipesPorAtendente = action.payload;
      state.loadingEquipesPorAtendente = false;
    });
    builder.addCase(fetchEquipesPorAtendente.rejected, state => {
      state.loadingEquipesPorAtendente = false;
    });
  },
});

// selectors

export const equipesSelector = (state: RootState) => state.equipes;

export default equipesSlice.reducer;
